import { searchRequestToQueryStringParams } from '@AppModels/UiUtils';
import { stringify as toQueryString } from 'query-string';
import { NavLink, useHistory } from 'react-router-dom';
import { IBulkContactsRequest, ISortDescriptor } from '../../../extViewmodels';
import { DefaultContactsSortDescriptor } from '../../../models';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '../../components/Breadcrumb';
import {
	AppDrawer,
	AppDrawerToolbar,
	AppDrawerToolbarButtonAiAssistant,
	StickyAppDrawerContent,
} from '../../components-v2/Drawer/AppDrawer';
import { ContactsSelfImport } from '../../components/contacts/ContactsSelfImport';
import { MultiContainerHeader } from '../../components/MultiContainerHeader';
import { ROUTES } from '../../constants/routes';
import { DefaultUniversalAssistantChat } from '../templates/AssistantChat';

export function ContactsImportFromCSVPage() {
	const history = useHistory();
	const onProcessingRequestClose = (contactsSearchRequestFilter?: IBulkContactsRequest) => {
		if (contactsSearchRequestFilter) {
			const sortDescriptor: ISortDescriptor = {
				...DefaultContactsSortDescriptor,
			};
			history.push({
				pathname: ROUTES.contacts.people,
				search: `${toQueryString(searchRequestToQueryStringParams(contactsSearchRequestFilter, sortDescriptor))}`,
			});
		}
	};
	return (
		<>
			<MultiContainerHeader
				appBarHeader={
					<Breadcrumb>
						<BreadcrumbList>
							<BreadcrumbItem>
								<BreadcrumbLink asChild>
									<NavLink to={ROUTES.contacts.people}>Contacts</NavLink>
								</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbSeparator />
							<BreadcrumbPage>CSV Import</BreadcrumbPage>
						</BreadcrumbList>
					</Breadcrumb>
				}
			/>
			<ContactsSelfImport onRequestClose={onProcessingRequestClose} />
			<AppDrawer>
				<StickyAppDrawerContent value='ai-assistant'>
					<DefaultUniversalAssistantChat />
				</StickyAppDrawerContent>
				<AppDrawerToolbar>
					<AppDrawerToolbarButtonAiAssistant value='ai-assistant' />
				</AppDrawerToolbar>
			</AppDrawer>
		</>
	);
}
